import { Injectable } from '@angular/core';

@Injectable()
export class NgxCmHelperLibService {

  constructor() { }
}
